import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '../../icons/ErrorIcon';
import { IconButton, Typography } from '@mui/material';
import MUISnackbar from '@mui/material/Snackbar';
import WarningIcon from '../../icons/WarningIcon';
import InfoIcon from '../../icons/InfoIcon';
import { styled } from '@mui/material/styles';

interface SnackbarProps {
  headline: string;
  message: string | React.ReactNode;
  variant?: 'error' | 'warning' | 'info';
  open: boolean;
  handleClose?: () => void;
  hiddenTime?: boolean;
}

const SnackbarContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant?: 'error' | 'warning' | 'info' }>(({ theme, variant }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: '400px',
  minHeight: '50px',
  background: 'white',
  padding: '1em',
  borderRadius: '3px',
  boxShadow: '0 12px 24px 4px rgba(40,42,43,0.2)',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
  ...(variant === 'error' && { borderLeft: '4px solid #D61F1F' }),
  ...(variant === 'warning' && { borderLeft: '4px solid #E46216' }),
  ...(variant === 'info' && { borderLeft: '4px solid #0263e0' }),
}));

const ContentContainer = styled('div')({
  display: 'flex',
  lineHeight: 1.8,
});

const IconContainer = styled('div')({
  display: 'flex',
  padding: '0 1.3em 0 0.3em',
  transform: 'translateY(3px)',
});



export default function Snackbar({ headline, message, variant, open, handleClose, hiddenTime }: SnackbarProps) {
  const handleOnClose = (_: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    handleClose?.();
  };

  return (
    <MUISnackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={open}
      onClose={handleOnClose}
      autoHideDuration={hiddenTime ? null : 10000}
    >
      <SnackbarContainer variant={variant}>
        <ContentContainer>
          <IconContainer>
            {variant === 'warning' && <WarningIcon />}
            {variant === 'error' && <ErrorIcon />}
            {variant === 'info' && <InfoIcon />}
          </IconContainer>
          <div>
            <Typography variant="body1" component="span" sx={{ fontWeight: 'bold' }}>
              {headline}
            </Typography>
            <Typography variant="body1" component="span">
              {' '}
              {message}
            </Typography>
          </div>
        </ContentContainer>
        <div>
          {handleClose && (
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
        </div>
      </SnackbarContainer>
    </MUISnackbar>
  );
}
